module.exports = __webpack_public_path__ + "7dfe83d20b3001ffe9a78f4126fa1f92.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/sites/fitness/logo.svg
// module id = 240
// module chunks = 1